import { apiConfig } from "./config";

export const reportApi = {
  order: async (from: number, to: number) => {
    const response = await apiConfig.get(
      `/api/front/chef/report/sale/${from}/${to}`
    );
    return response;
  },
  penalty: async (from: number, to: number) => {
    const response = await apiConfig.get(
      `/api/front/chef/report/penalty/${from}/${to}`
    );
    return response;
  },
  archive: async (from: number, to: number) => {
    const response = await apiConfig.get(
      `/api/front/chef/report/order/${from}/${to}`
    );
    return response;
  },
  score: async (from: number, to: number) => {
    const response = await apiConfig.get(
      `/api/front/chef/report/Score/${from}/${to}`
    );
    return response;
  },
};
